/* One row of a DataTable; cells are plain <td> elements styled by the table. */
type DataTableRowProps = {
    className?: string;
    selected?: boolean;
    children: React.ReactNode;
};

const DataTableRow = ({ className, selected, children }: DataTableRowProps) => (
    <tr className={className} aria-selected={selected || undefined}>
        {children}
    </tr>
);

export default DataTableRow;
